import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as UserReducer from '../../redux/reducers/User';

export const useCurrentUser = () => {
  const { data: currentUser } = useSelector(UserReducer.getCurrentUser);
  const user = useMemo(
    () => currentUser,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(currentUser)]
  );
  return {
    user,
  };
};
